import { render, staticRenderFns } from "./TheBurgerButton.vue?vue&type=template&id=4762f076"
import script from "./TheBurgerButton.vue?vue&type=script&lang=js"
export * from "./TheBurgerButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports